// Pure: apply a dropped text-area-able element's block style to a cell's text
// area. The (empty) cell adopts the element's content + placeholder, so the
// native text area renders+edits as the dropped style (e.g. a title). No child
// is created — this is the transform-on-empty path.

interface CellTextShape {
  content?: string;
  placeholder?: string;
}
interface TextElSettings {
  name?: string;
  content?: string;
  placeholder?: string;
}

export const buildCellTextTransform = (
  cell: CellTextShape,
  element: TextElSettings,
): { content: string; placeholder: string } => ({
  content: element.content ?? "",
  placeholder: element.placeholder ?? cell.placeholder ?? "",
});
